import { createStore } from "vuex";
import axios from "@/http";

const store = createStore({
    state: {
        user: null,
        token: localStorage.getItem("token") || null,
        step: localStorage.getItem("step") || null
    },
    mutations: {
        setUser(state, payload) {
            state.user = { ...state.user, ...payload }
        },
        setToken(state, payload) {
            state.token = payload
        },
        removeToken(state) {
            state.token = null
            localStorage.removeItem('token')
        },
        setStep(state, payload) {
            localStorage.setItem('step', payload)
            state.step = payload
        }
    },
    getters: {
        step(state) {
            const step = state.step

            if (!step)
                return 1

            const stepObj = JSON.parse(state.step)

            if (state.user && stepObj.user === state.user.id)
                return stepObj.page

            else
                return 1
        }
    },
    actions: {
        async signin(context, { email, password }) {
            const res = await axios.post("/signin", { email: email, password: password })
            if (res.data.success) {
                context.commit('setUser', res.data.user)
                context.commit('setToken', res.data.token)

                localStorage.setItem("token", res.data.token)
            } else {
                throw new Error(res.data.message)
            }
        },
        async signup(context, { email, password, firstname, lastname, gender, age, organisation }) {
            const res = await axios.post("/signup", { email, password, firstname, lastname, gender, age, organisation })
            if (res.data.success) {
                context.commit('setUser', res.data.user)
                context.commit('setToken', res.data.token)

                localStorage.setItem("token", res.data.token)
            } else {
                throw new Error(res.data.message)
            }
        },
        async updateUser(context, { firstname, lastname, gender, age, organisation, id = false }) {
            const userId = id || context.state.user.id
            const res = await axios.post("/updateUser", { firstname, lastname, gender, age, organisation, id: userId },
                {
                    headers: { 'Authorization': `Bearer ${context.state.token}` }
                })
            if (res.data.success) {
                context.commit('setUser', res.data.user)
            } else {
                throw new Error(res.data.message)
            }
        },
        async updateUserPassword(context, { oldPassword, password, passwordConfirm, id = false }) {
            const userId = id || context.state.user.id
            const res = await axios.post("/updateUserPassword", { oldPassword, password, passwordConfirm, id: userId },
                {
                    headers: { 'Authorization': `Bearer ${context.state.token}` }
                })
            if (!res.data.success) {
                throw new Error(res.data.message)
            }
        },
        signout(context) {
            context.commit('removeToken')
        }
    }
});


export default store